import React, { createRef } from 'react';

import withAppState from '../mobx/withAppState';
import { Steps } from '../lib/constants';
import compareItemChoices from './../lib/compareItemChoices'

import NavMenu from './NavMenu';
import MenuPages from './MenuPages';
import MenuItem from './MenuItem';
import Loading from './Loading';
import MenuBasket from './MenuBasket';
import Header from './Header';
import MenuFooter from './MenuFooter';
import MenuFooterLinks from './MenuFooterLinks';
import SwipeableContainer from './Swipeable';
import StickyFooter from './StickyFooter';

import TagManager from 'react-gtm-module';
import LoyaltyLoading from './LoyaltyLoading';

const getDescriptionInfo = (description) => {
    let descriptionInfo = { description: '', subTitle: '', title: '', info: '' };
    description.split('\r\n').forEach((line) => {
        if (line.startsWith('###')) descriptionInfo.subTitle += line.substring(3);
        else if (line.startsWith('##')) descriptionInfo.title += line.substring(2);
        else if (line.startsWith('#')) descriptionInfo.info += line.substring(1);
        else descriptionInfo.description += line;
    });

    return descriptionInfo;
};

const recursivelyTransformMenuCategories = (menuCategories, dietaryFilter) => {
    if (menuCategories != null && menuCategories.length > 0) {
        menuCategories.forEach((category) => {
            const { menuItems, menuCategories } = category;
            if (menuItems != null && menuItems.length > 0) {
                menuItems.forEach((item) => {
                    const { dietaryAndAllergens, description } = item;
                    const descriptionInfo = getDescriptionInfo(description);
                    item.descriptionInfo = descriptionInfo;
                    if (dietaryAndAllergens != null && dietaryAndAllergens.length > 0) {
                        dietaryAndAllergens.forEach((dietaryAllergen) => {
                            if (dietaryFilter[dietaryAllergen] === undefined) {
                                dietaryFilter[dietaryAllergen] = false;
                            }
                        });
                    }
                });
            }
            recursivelyTransformMenuCategories(menuCategories, dietaryFilter);
        });
    }
};

const recursiveMenuCategoryDietaryFilter = (category, dietaryFilter) => {
    const { menuItems, menuCategories } = category;
    const filteredMenuItems = menuItems
        ? menuItems.filter((item) => {
            const {
                uiTags = [],
                dietaryAndAllergens = []
            } = item;
            for (let key in dietaryFilter) {
                if (dietaryFilter[key] === true) {
                    if (dietaryAndAllergens.includes(key) === false) return false;
                }
            }
            if (uiTags.includes("Vegan Alternative")) return dietaryFilter["Vegan"];
            return true;
        })
        : [];
    category.menuItems = filteredMenuItems;

    const filteredMenuCategoriesResult = !menuCategories
        ? []
        : menuCategories.filter((c) =>
            recursiveMenuCategoryDietaryFilter(c, dietaryFilter)
        );
    category.menuCategories = filteredMenuCategoriesResult;

    if (filteredMenuCategoriesResult.length > 0 || filteredMenuItems.length > 0) {
        return true;
    } else {
        return false;
    }
};

class PreOrderMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      filteredData: null,
      results: null,
      loading: true,
      currentPage: 0,
      popoutActive: false,
      dietFilterOpen: false,
      dietaryFilter: {},
      focusedItem: null,
      navSelected: false,
      scrollItemIndex: 0,
      basket: this.props.getBasket(),
      slideUpModal: false,
      isMobile: false
    };
    this.requests = [];
    this.menuPage = createRef();
    this.menuBanner = createRef();
    this.scrollWrapper = createRef();
    this.scrollContainer = createRef();
    this.navMenuWrapper = createRef();
    this.navMenuContainer = createRef();
    this.isOrderJourney = props.isOrderJourney;
    this.isCheckInJourney = props.isCheckInJourney;
  }

    handleRestaurantSelect = (restaurant) => {
        this.props.selectRestaurant(restaurant);
        
        if (this.isOrderJourney) {
    
         if(!this.isCheckInJourney){
            this.props.goToStep(Steps.PRE_ORDER);
          }
          else{
            if (this.props.getDataCaptureStatusForCurrentRestaurant() === true) this.props.goToStep(Steps.PRE_ORDER);
           else this.props.goToStep(Steps.PRE_ORDER_DATA_CAPTURE);
    
          }
      } else {
          this.props.goToStep(Steps.TABLE_PICKER);
        }
      }


  focusItem(item) {
      this.setState({
          focusedItem: item,
          slideUpModal: true
      });
  }

    addToBasket(item, itemChoices) {
        const tagManagerArgs = {
            dataLayer: {
                itemAdded: {
                    id: item?.id,
                    name: item?.name,
                },
                itemAddedChoices: itemChoices
            },
            dataLayerName: 'dataLayer'
        }
        TagManager.dataLayer(tagManagerArgs)

        const { basket } = this.state;
        const basketItems = basket.filter(basketItem => basketItem.id === item.id);

        let foundSameChoices = false;
        if (basketItems.length > 0) {
            const basketItemCount = basketItems.length;
            for (let i = 0; i < basketItemCount; i++) {
                const basketItem = basketItems[i];
                const hasSameChoiceTree = compareItemChoices(itemChoices, basketItem.itemChoices);
                if (hasSameChoiceTree) {
                    basketItem.qty += 1;
                    foundSameChoices = true;
                    break;
                }
            }
        }

        if (!foundSameChoices) basket.push({ item, qty: 1, id: item.id, itemChoices });

        this.setBasket(basket);
        this.setState({ focusedItem: null });
    }

    setBasket(basket) {
        this.setState({ basket });
        this.props.setBasket(basket);
    }

    changeQuantity(obj, increment) {
        const { basket } = this.state;
        const basketObj = basket.find((basketObj) => basketObj === obj);

        basketObj.qty += increment;

        if (basketObj.qty <= 0) {
            basket.splice(basket.indexOf(basketObj), 1);
        }

        this.setBasket(basket);
    }

    homeButtonHandler() {
        this.props.homeButtonHandler();
    }

    backButtonHandler() {
        const { currentPage, filteredData } = this.state;
        const rootCategories = (filteredData && filteredData.menuCategories) || [];
        const pageCount = rootCategories.length;

        if (this.state.focusedItem !== null) {
            this.setState({ focusedItem: null });
        } else if (pageCount > 0 && currentPage === pageCount) {
            this.setState({ currentPage: 3 }); // TODO(john): We need to build a proper history of pages selection on menu 
        } else {
            this.props.backButtonHandler();
        }
    }

    closeFocusedItem() {

        const clearItem = () => {
            this.setState({ focusedItem: null });
            this.props.clearSlideUpModalContents();
        }

        if (this.state.focusedItem !== null) {
            this.setState({ slideUpModal: false });
            if (this.state.slideUpModal) {
                clearTimeout(clearItem())
            } else {
                setTimeout(() => {
                    clearItem()
                }, 300);
            }
        }
    }

    setPage(value) {
        const { currentPage } = this.state;
        if (currentPage !== value) this.setState({ currentPage: value });
        if (this.state.focusedItem !== null) this.setState({ focusedItem: null });

        this.menuPage.current.scrollTo(0, 0);
        this.setState({ popoutActive: false });

    }

    togglePopout() {
        this.setState({ popoutActive: !this.state.popoutActive });
    }

    toggleDietFilterMenu() {
      if (this.state.dietFilterOpen) {
          setTimeout(() => {
              this.setState({ dietFilterOpen: false });
              this.props.clearSlideUpModalContents();
          }, 300);
      } else {
          this.setState({ dietFilterOpen: true });
      }
  }

    getFilteredData(data, dietaryFilter) {
        const result = JSON.parse(JSON.stringify(data));
        result.menuCategories.forEach((c) =>
            recursiveMenuCategoryDietaryFilter(c, dietaryFilter)
        );
        return result;
    }

    handleDietaryFilterChange({ target: { checked } }, name) {
        const { dietaryFilter, data } = this.state;
        dietaryFilter[name] = checked;

        const filteredData = this.getFilteredData(data, dietaryFilter)

        this.setState({ dietaryFilter, filteredData });
    }

    handleDietaryResetAll() {
        const { dietaryFilter, data } = this.state;

        Object.keys(dietaryFilter).forEach(name => dietaryFilter[name] = false);

        const filteredData = this.getFilteredData(data, dietaryFilter)

        this.setState({ dietaryFilter, filteredData });
    }

  getPage = () => {
    const { filteredData} = this.state;
    const pathName = window.location.pathname.substr(1);
    var category;
    var pathArray = pathName.split('/');
    pathArray = pathArray.filter(path => path !== "");

    const { dietaryFilter, data } = this.state;
    let index = !filteredData ? 2 : filteredData.menuCategories.findIndex(m => m.name.toLowerCase() === 'pizzeria');
    index = index !== -1 ? index : 2;
    if (pathArray.length == 0) {
      this.setState({ currentPage: index });
      return;
    };

    switch (pathArray[pathArray.length - 1].toLowerCase()) {
      case "restaurant-menu":
      case "main-menu":
        category = index;
        break;
      case "lunch-menu":
        category = 6;
        break;
      case "piccolo-menu":
        index = !filteredData ? 5 : filteredData.menuCategories.findIndex(m => m.name.toLowerCase() === 'kids');
        category = index;
        break;
      case "vegan-menu":
        category = 2;
        dietaryFilter['Vegan'] = true;
        break;
      default:
        category = 0;
    }

        this.setState({ currentPage: category });

    }

  async loadMenus() {
    this.setState({loading: true});
    const { restaurant } = this.props;
    let response = {};
    
    //let params = new URL(document.location.toString()).searchParams;
    //let restaurantUrlId = params.get("restaurantId");
      
    if (restaurant?.id) //at the point when the user chooses or changes the restaurant
    {
        response = await fetch(`api/Menu/GetMenu/${restaurant.id}`);
    }
    else {
        response = await fetch(`api/Menu/GetGlobalMenu`);
    }
    
    if (response?.status === 200) {
        let data;
      try {
        const json = await response.json();
          data = json.data;          
      } catch (error) { }

      if (!data) {
                this.setState({ filteredData: null, loading: false });
        return;
      }

            const { menuCategories } = data;

            const dietaryFilter = {};
            recursivelyTransformMenuCategories(menuCategories, dietaryFilter);

            data = { ...data, menuCategories: menuCategories.filter(fd => fd.menuCategories.length >= 1) };
            const filteredData = this.getFilteredData(data, dietaryFilter)

            this.setState({ data, filteredData, dietaryFilter });

            this.getPage();
        }

        this.setState({ loading: false });
    }

    async componentDidUpdate (prevProps) {

        if(prevProps?.restaurant)
        {
            if(prevProps.restaurant?.id !== this.props.restaurant?.id)
            {
                await this.loadMenus();
            }
        }
      }
  async componentDidMount() {
    await this.loadMenus();
  }


    handleScroll(e) {
        const { filteredData, currentPage, scrollItemIndex } = this.state;
        const scrollContainer = this.scrollContainer.current;
        if (scrollContainer !== null) {
            var navContainerSize = scrollContainer?.getBoundingClientRect();
            const scrollWrapper = this.scrollWrapper.current;
            const rootCategories = filteredData.menuCategories || [];
            const selectedMenu = rootCategories[currentPage];
            const { menuCategories } = selectedMenu;
            let selectedIndex = 0;
            for (let i = 0; i < menuCategories.length; i++) {
                const { titleRef: categoryRef } = menuCategories[i];
                const { top: categoryTop } = categoryRef.current?.getBoundingClientRect();
                if (categoryTop - 25 <= navContainerSize.bottom) {
                    selectedIndex = i;
                } else {
                    break;
                }
            }
            if (scrollItemIndex !== selectedIndex) {
                this.setState({ scrollItemIndex: selectedIndex })
                const { navRef } = menuCategories[selectedIndex];
                const { x } = navRef.current?.getBoundingClientRect()
                scrollWrapper.scrollTo({
                    left: (x) - navContainerSize.x,
                });
            }
        }
    }

  mainComponent = () => {
    const { focusedItem, filteredData, currentPage, popoutActive, dietaryFilter } = this.state;
    const { basket } = this.state;
    const {loading} = this.state;
    const filteredCategories = filteredData?.menuCategories || [];
    const categoryType = filteredCategories[currentPage]?.name;
    const {data} = this.state;
    var noMenuMinHeight = window.innerHeight - 11 - (this.props.appHeaderHeight + this.props.appFooterHeight);
    if (!filteredData)
    {
      //no menu page will always have a no menu restaurant name in the url
      var pathArray = window.location.pathname.split("/").filter(p => p);
      pathArray.shift();
      var pathname = pathArray.join('/');

      var globalMenuUrl = window.location.origin + "/" + pathname;      
        
      return (
               <>
                    {loading && <Loading />}
                    {!filteredData && !loading && (    
                        <div style={{minHeight: noMenuMinHeight > 0 ? noMenuMinHeight : 0 }} className="no-menu-container">
                            <p style={{paddingTop: '8px'}}><a href={globalMenuUrl} style={{ textDecoration: 'underline', color: 'black' }}>Back to Main Menu</a></p>
                            <p style={{padding: '5px'}}>Sorry! We do not have an online menu for this restaurant yet.</p>
                        </div>
                    )}

               </>
      );
    }

        return (
            <>

        <MenuPages
          data={filteredData}
          categoryType={categoryType}
          selectedIndex={currentPage}
          culture={this.props.culture}
          popoutActive={popoutActive}
          focusItem={(item) => this.focusItem(item)}
          handleScroll={(e) => this.handleScroll(e)}
          activeStep={this.props.activeStep}
        >
          <MenuBasket
            items={basket}
            increaseQuantity={(obj) => this.changeQuantity(obj, 1)}
            reduceQuantity={(obj) => this.changeQuantity(obj, -1)}
          />
        </MenuPages>
        <MenuItem
          hasBasket={false}
          dietaryFilter={dietaryFilter}
          filterDiet={Object.keys(dietaryFilter).some(key => dietaryFilter[key])}
          item={focusedItem}
          categoryType={categoryType}
          slideUpModal={this.state.slideUpModal}
          culture={this.props.culture}
          backButtonHandler={() => this.closeFocusedItem()}
          addToBasket={(item, itemChoices) => this.addToBasket(item, itemChoices)}
        />
      </>
    );
  };

    render() {
        const {
            focusedItem,
            filteredData,
            currentPage,
            popoutActive,
            dietFilterOpen,
            dietaryFilter,
            loading,
            scrollItemIndex            
        } = this.state;
        const { basket } = this.state;

        if (loading)
            return (
                <div className="loading-container">
                    <Loading />
                </div>
            );

      const { isLocalMenuFirstLoaded } = this.props;
      const { activeStep } = this.props;

      if(!!isLocalMenuFirstLoaded && activeStep != Steps.PRE_ORDER)
      return (
        <div className="loading-container">
            <Loading />
        </div>
      );

    const dietaryFilterActive = Object.keys(dietaryFilter).length > 0;
    const dietaryFilterCounter = Object.keys(dietaryFilter).reduce((acc, key) => {
      return acc + (dietaryFilter[key] === true ? 1 : 0)
    }, 0);

        const rootCategories = (filteredData && filteredData.menuCategories) || [];
        const pageCount = rootCategories.length;
        const basketCount = basket.length > 0 && basket.reduce((acc, item) => acc + item.qty, 0);

        const categoryName = rootCategories[currentPage]?.name;
        const subcategory = rootCategories[currentPage]?.menuCategories[scrollItemIndex]?.name;
        const item = focusedItem?.name

    const tagManagerArgs = {
      dataLayer: {
        category: categoryName,
        subcategory: subcategory,
        item: item,
      },
      dataLayerName: 'dataLayer'
    }
    TagManager.dataLayer(tagManagerArgs)
    window.dataLayer.push({ 'set-page-event': categoryName + '/' + subcategory });
    return (
      <>
        <div key={'main-menu-key-prop'} onScroll={(e) => this.handleScroll(e)} ref={this.menuPage} className="menu-page">
          <Header logo={this.props.logo} />
          {filteredData && <NavMenu
            rootCategories={rootCategories}
            selectedIndex={currentPage}
            navMenuWrapper={this.navMenuWrapper}
            navMenuContainer={this.navMenuContainer}
            popoutActive={popoutActive}
            dietaryFilterCta={() => dietaryFilterActive && !this.toggleDietFilterMenu()}
            dietaryFilter={dietaryFilter}
            scrollContainer={this.scrollContainer}
            scrollWrapper={this.scrollWrapper}
            togglePopout={() => this.togglePopout()}
            setIndex={(page) => this.setPage(page)}
            scrollItemIndex={scrollItemIndex}
            displaySubcategories={!!rootCategories && currentPage <= rootCategories.length && focusedItem === null}
            menuBanner={this.menuBanner}
            menuPage={this.menuPage}
            handleRestaurantSelect={this.handleRestaurantSelect}
          />}
          {this.mainComponent({ focusedItem, filteredData, currentPage, popoutActive, basket })}
          

                <div
                    className={`modal-slide-bg ${dietFilterOpen ? 'active' : ''}`}
                    onClick={() => dietaryFilterActive && !this.toggleDietFilterMenu()}></div>
                <SwipeableContainer
                    isMobile={this.state.isMobile}
                    handleModalCancel={() => dietaryFilterActive && !this.toggleDietFilterMenu()}
                    slideUpModal={dietFilterOpen}
                    customClass="dietary-filter-slider"
                    customInnerClass="dietary-filter-slider-inner">
                    <div className="modal-slide-up-inner diet-filter-container">
                        <div className="diet-filter-container-inner">
                            <div className="diet-filter-popup">
                                <div className="slide-draw-bar"></div>
                                <h3>FILTER BY DIET</h3>
                                <div className="diet-filter-copy">
                                    <p>Click to filter the menu by dietary requirement and remember to let our team know when you order.</p>
                                </div>
                                <div className="diet-filter-list">
                                    {Object.keys(dietaryFilter).map((item, index) => {
                                        const id = `${index}-${item.toLowerCase()}`;
                                        return (
                                            <label className={'filter-type-' + item.toLowerCase()} key={index} htmlFor={id}>
                                                <span className="diet-filter-selector">
                                                    <p>{item}</p>
                                                    <input
                                                        id={id}
                                                        key={'checkbox' + index}
                                                        type="checkbox"
                                                        checked={dietaryFilter[item]}
                                                        onChange={e => this.handleDietaryFilterChange(e, item)}
                                                    />
                                                </span>
                                                <span className={`icon ${item.toLowerCase()}`}></span>
                                            </label>
                                        );
                                    })}
                                </div>
                                <div className="diet-filter-cta">
                                    <button className="menu-cta secondary-cta clear-cta" onClick={() => this.handleDietaryResetAll()}>
                                        <p>Clear selection</p>
                                    </button>
                                    <button className="menu-cta primary-cta close-cta" onClick={() => !this.toggleDietFilterMenu()}>
                                        <p>confirm</p>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwipeableContainer>

                    <MenuFooter
                        brand={'Milano'}
                        hasMarginTop={false}
                    >
                        <MenuFooterLinks />
                    </MenuFooter>
                </div>
            </>

        );
    }
}


export default withAppState(PreOrderMenu, {
  mobXActions: ({
    getBasket,
    setBasket,
    clearSlideUpModalContents,
    selectRestaurant,
    goToStep
  }) => ({
    getBasket,
    setBasket,
    clearSlideUpModalContents,
    selectRestaurant,
    goToStep
  }),
  mobXProps: ({
    restaurant,
    culture,
    appFooterHeight,
    appHeaderHeight,
    isLocalMenuFirstLoaded    
  }) => ({
    restaurant,
    culture,
    appFooterHeight,
    appHeaderHeight,
    isLocalMenuFirstLoaded    
  }),
});